import { CriteriaFunction } from './criteria-function.model';

export class EqualsCriteriaFunction implements CriteriaFunction {
  supportsValue(value: any): boolean {
    return value && !!value.equals;
  }

  getFilter<T>(key: string, value: any): (t: T) => boolean {
    return (t: T) => {
      const compareValue: string = t[key];
      const criteria = value.equals;

      if (criteria) {
        const c: any[] = Array.isArray(criteria) ? criteria : [criteria];

        return c.some((val) => compareValue === val);
      }

      return true;
    };
  }
}
